export function getPublicUrl() {
	return config.public_url.substr(-1) === '/' ? config.public_url.slice(0, -1) : config.public_url;
}

export function getWwwUrl() {
	return config.www_url.substr(-1) === '/' ? config.www_url.slice(0, -1) : config.www_url;
}

export function detectLanguageParameter() {
	const path = window.location.pathname;

	if (path.includes('/lang/')) {
		return path.substring(path.lastIndexOf('/lang/') + 6, path.lastIndexOf('/lang/') + 8);
	}

	let language = URL.parse(window.location.href).searchParams.get("lang");
	if (language) {
		return language;
	}

	if (path.substring(path.lastIndexOf('/')).length === 3) {
		return path.substring(path.lastIndexOf('/') + 1, path.lastIndexOf('/') + 3);
	}

	language = document.querySelector('html head').getAttribute('lang') || document.querySelector('html').getAttribute('lang');
	if (language) {
        return language.substring(0, 2);
    }
	return 'en';
}